import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";

class rackDataAccess {
  updateRecipeLocation(params: { id: number; isRecipeLocation: boolean }) {
    return commonDataAccess.putData(
      "rack/update/recipe-location",
      null,
      params
    );
  }
  rackList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData("rack/getall", parameters);
  };

  updatePutAway = async (params: {
    id: number | bigint;
    isPutAway: boolean;
  }) => {
    var result = await commonDataAccess.putData(
      "rack/update/putAway",
      {},
      params
    );
    return result;
  };

  getRackInfo = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "rack/get/rackInfo/" + params,
      {}
    );
    return result;
  };
  saveRackInfo = async (data: any) => {
    var result = await commonDataAccess.postData("rack/save/rackInfo", data);
    return result;
  };

  deleteRackInfo = async (params: { ids: string }) => {
    var result = await commonDataAccess.deleteData("rack/delete/" + params);
    return result;
  };
  getRackData() {
    return commonDataAccess.downloadFile("rack/export/datatopdf");
  }
  exportDataToExcel() {
    return commonDataAccess.downloadFile("rack/export/datatoexcel");
  }
  getAllRackDropdown = () => {
    return commonDataAccess.getData("rack/get/allRack");
  };
  getProductRackLocationDropdown(productId: string) {
    return commonDataAccess.getData("product/get/ProductrackLocation", {
      productId: productId,
    });
  }
  getRecipeLocationDropDown = () => {
    return commonDataAccess.getData("rack/get/getRecipeLocationDropDown");
  };
}

export default new rackDataAccess();
